import { useDispatch, useSelector } from 'react-redux';
import {loadPlayerNote, loadPlayersNoteType, updatePlayerNote}  from '../actions/playerNotes';
import { RootState } from '../reducers';

export const usePlayerNoteState = () => {
  const  modalPlayerNote  = useSelector((state: RootState) => state.playerNote.modalPlayerNote);
  const  playersNoteTypes  = useSelector((state: RootState) => state.playerNote.playersNoteTypes);
  return {modalPlayerNote, playersNoteTypes};
};

export const usePlayerNoteDispatch = () => {
  const dispatch = useDispatch();
  return {
        loadPlayerNote: (gameId: string, playerId: string) => dispatch(loadPlayerNote(gameId, playerId)),
        loadPlayersNoteType: (gameId:string) => dispatch(loadPlayersNoteType(gameId)),
        updatePlayerNote: (playerNote:string, noteType: string, gameId: string, playerId:string, teamId:string) => 
        dispatch(updatePlayerNote(playerNote, noteType, gameId, playerId, teamId))
  };
};